<script setup lang="ts">
import { onMounted } from "vue";

import { useMemberService } from "@/stores/memberFunction/memberService";
import USDT2Withdraw from "@/components/menberFunction/withdrawPage/USDTwithdraw.vue";

import SidebarWeb from "@/components/menberFunction/functionNavbar/sidebarWeb.vue";

const memberService = useMemberService();

onMounted(() => {
  memberService.toUSDTWithdrawPage();
});
</script>

<template>
  <div class="md:grid grid-cols-12 gap-x-[3vw] block gap-y-[1dvh] px-[1vw] pb-[140px] pt-0 md:pt-[3rem]">
    <SidebarWeb class="col-span-3 hidden md:block mb-[7dvh]" />
    <div class="col-span-9 relative">
      <div class="px-0 pt-0 pb-0 md:px-[5vw] md:pt-[2dvh] md:pb-[4dvh] relative z-10 web-gold-border rounded-[24px]">
        <p class="mt-[1dvh] text-[24px] text-primary font-bold hidden md:block">
          {{ $t("MemberFunction.Withdraw.Withdraw") }}
        </p>
        <div class="relative member-in-bg w-full h-full">
          <!-- main -->
          <USDT2Withdraw />
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.bg-100 {
  background-size: 100% 100%;
}
</style>
